import React, { Component } from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import { propTypes } from '../../util/types';
import { obfuscatedCoordinates } from '../../util/maps';
import { Heading, Map } from '../../components';

import css from './ListingPage.module.css';
import { normalizeDeliveryOptions } from '../../util/data';


class SectionMapMaybe extends Component {
  constructor(props) {
    super(props);
    this.state = { isStatic: true };
  }

  render() {
    const { className, rootClassName, geolocation, publicData, listingId, mapsConfig, locationText, title } = this.props;

    const normalisedAccessibilityOptions = normalizeDeliveryOptions(publicData?.access_to_rentals || []).join(', ');
    const mainHeading = !!normalisedAccessibilityOptions
      ? <>{title} is available for {normalisedAccessibilityOptions}<span className={css.locationText}>{locationText}</span></>
      : <>{title} is available for rental <span className={css.locationText}>{locationText}</span></>;

    if (!geolocation) {
      return null;
    }

    const address = publicData && publicData.location ? publicData.location.address : '';
    const classes = classNames(rootClassName || css.panel, className);
    const cacheKey = listingId ? `${listingId.uuid}_${geolocation.lat}_${geolocation.lng}` : null;

    const mapProps = mapsConfig.fuzzy.enabled
      ? { obfuscatedCenter: obfuscatedCoordinates(geolocation, mapsConfig.fuzzy.offset, cacheKey) }
      : { address, center: geolocation };
    const map = <Map {...mapProps} useStaticMap={false} />;

    return (
      <div className={classes}>
        <h4 className={css.headingMap}>Item Location</h4>
        <Heading as="h3" rootClassName={css.textMap}>
          {/* <FormattedMessage id="ListingPage.locationTitle" /> */}
          {mainHeading}
        </Heading>
        {this.state.isStatic ? (
          <button
            className={css.mapBox}
            onClick={() => {
              this.setState({ isStatic: false });
            }}
          >
            {map}
          </button>
        ) : (
          <div className={css.mapBox}>{map}</div>
        )}
      </div>
    );
  }
}

SectionMapMaybe.defaultProps = {
  rootClassName: null,
  className: null,
  geolocation: null,
  listingId: null,
};

SectionMapMaybe.propTypes = {
  rootClassName: string,
  className: string,
  geolocation: propTypes.latlng,
  listingId: propTypes.uuid,
};

export default SectionMapMaybe;